<template>
    <div class="row" style="margin-bottom: 3rem;">
        <div class="col-12" style="display: flex;">
            <h4 class="title title--s" style="margin-bottom: 1rem;">Prize #{{ index + 1 }}</h4>
            <a href="#" style="margin-left: auto;" v-if="index > 0" @click="onRemoveClick(index)">Remove</a>
        </div>
        <div class="col-5">
            <input type="hidden" :name="`prizes[${index}][type]`" :value="type">

            <select
                class="formInput | formSelect"
                :name="`prizes[${index}][product]`"
                :disabled="isSelectDisabled"
            >
                <option v-for="(item, j) in availablePrizes" :selected="item.id == product" :key="`prizeItem_${j}`" :value="item.id" v-html="item.name"></option>
            </select>
        </div>
        <div class="col-2" style="display: flex; align-items: center; justify-content: center;">
            or
        </div>
        <div class="col-5">
            <input type="text" class="formInput" :name="`prizes[${index}][label]`" v-model="label" placeholder="Description">
        </div>
    </div>
</template>

<script>

export default {


    /* Settings
    --------------------------------------------------------- */

    name: 'ActionBuilderPrizeSelectorRow',

    components: {
    },

    props: {
        index: {
            type: Number,
            required: true,
        },
        prize: {
            type: Object,
            required: true,
        },
        availablePrizes: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            label: this.prize.label,
            product: this.prize.product,
        }
    },




    /* Life Cycle
    --------------------------------------------------------- */

    created() {
    },


    mounted() {
        //
    },




    /* Data Handling
    --------------------------------------------------------- */

    computed: {
        isSelectDisabled() {
            return this.type === 'custom'
        },
        type() {
            return this.label && this.label.length > 0 ? 'custom' : 'product'
        },
    },


    watch: {
        //
    },




    /* Methods
    --------------------------------------------------------- */

    methods: {
        onRemoveClick(index) {
            this.$emit('remove', index)
        },
    },


}

</script>
